import React from 'react';
import { SearchX } from 'lucide-react';

export default function EmptyState({ message = 'Нет данных для отображения', hint }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-text-disabled">
      <SearchX className="w-16 h-16 mb-4" />
      <p className="text-lg font-medium">{message}</p>
      {hint && <p className="text-sm mt-2">{hint}</p>}
    </div>
  );
}
